<template>

  <div :class="[ removeHeaderDivider ? '' : 'ba-header-border', removeFooterDivider ? '' : 'ba-footer-border', 'uk-card', 'uk-card-default', 'uk-width-1-1']">
      <div class="uk-card-header" v-if="hasHeaderSlot">
        <slot name="header"></slot>
      </div>
      <div class="uk-card-body" v-if="hasBodySlot">
        <slot name="body"></slot>
      </div>
      <div class="uk-card-footer" v-if="hasFooterSlot">
        <slot name="footer"></slot>
      </div>
  </div>

</template>

<script>
export default {
  name: 'Card',
  computed: {
    hasBodySlot() {
      return !!this.$slots.body
    },
    hasHeaderSlot() {
      return !!this.$slots.header
    },
    hasFooterSlot() {
      return !!this.$slots.footer
    }
  },
  props: {
    removeFooterDivider: {
      required: false
    },
    removeHeaderDivider: {
      required: false
    },
  }
}
</script>

<style scoped lang="less">
  @import "../../assets/less/theme.less";

  .ba-footer-border {
    > .uk-card-footer {
      border-top: 1px solid @ba-off-white;
    }
  }
  .ba-header-border {
    > .uk-card-header {
      border-bottom: 1px solid @ba-off-white;
    }
  }
  .uk-card-body {
    padding: 20px 40px;
  }
</style>
